import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'postFlag'
})
export class PostFlagPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    var state = false;

    // Basic null/undefined check for args
    if (!args) {
      return false;
    }

    // Ensure users is always an array
    var users = Array.isArray(args.users) ? args.users : [];
    var userId = (typeof args.userId !== 'undefined') ? args.userId : null;
    var isManager = args.isManager === 'true';
    var type = args.type || '';
    var isButtonTrue = args.button === 'true';

    if (users.length === 0) {
      if (type === 'flag') {
        state = true;
      } else if (type === 'unflag') {
        state = false;
      }
    } else if (isButtonTrue) {
      if (users.length > 0 && isManager) {
        state = (type === 'flag') ? false : true;
      } else {
        state = this.checkUser(users, userId, type);
      }
    } else {
      if (users.length > 0 && isManager) {
        state = (type === 'flag') ? false : true;
      } else {
        state = this.checkUser(users, userId, type);
      }
    }

    return state;
  }

  private checkUser(users: any[], userId: any, type: string): boolean {
    for (var i = 0; i < users.length; i++) {
      if (users[i] && users[i].id === userId) {
        return (type === 'flag') ? false : true;
      }
    }
    return (type === 'flag') ? true : false;
  }
}
